import { makeAutoObservable, observable, toJS  } from "mobx";
import mainStore from "../../home/store/mainStore";
import { saveAs } from "file-saver";
import { MaterialService } from "../services/materialservices";
import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import { message, notification } from "antd";
class MaterialStore {
  constructor() {
    makeAutoObservable(this);
  }

  showAddDialog = false;
  showStockDialog = false;
  showHistoryDialog = false;
  selChem = {};
  isLoadingChemicals = false;
  showNaocDailyProductionDialog = false;

  chemicals = observable.map({});
  stockHistory = observable.map({});
  materialConsumptions = observable.map({});
  selTab = "1";
  showMQeryDialog = false;
  isDownloadingTemplate = false;
  mainStore = mainStore;
  
  isExporting = false;
  isSaving = false;
  isLoading = false;
  isLoaded = false;
  isprocessing = false;
  sheetName = "";
  showUploadErrorMessage = false;
  isfiltering = false;
  productionview = "gross";
  showRemarkPane = false;
  remarkObj = { title: "", remark: "<div></div>" };
  resultFromQuery = false;
  addChemicalAction = "add";
  view = "upload";
  savingHistory = false;
  uploadDate = moment(new Date()).format("DD-MMM-YYYY");
  gridHeaderText = ` Material consumptions from ${moment(new Date())
    .startOf("month")
    .format("ddd DD-MMM-YYYY")} to ${moment(new Date())
    .endOf("month")
    .format("ddd DD-MMM-YYYY")}`;
  addChemicalFormData = {
    chemicalId: 0,
    name: "",
    unit: "",
    unitAbbr: "",
    stock: 0,
    assetId: mainStore.assetContextId,
  };

  stockData = {
    chemicalId: 0,
    name: "",
    change: 0,
    changeDate: null,
    restockTime: null,
    restockParty: "",
    assetId: mainStore.assetContextId,
    cost: 0,
    uploadedBy: "",
    uploadedOn: "",
    approvedParty: "",
    remarks: "",
    vendor: "",
    currentStock: 0,
  };
  initFormaData = {};
  uploadErrors = [];
  selRow = {};
  queryCriteria = {
    startDate: moment(new Date())
      .startOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    endDate: moment(new Date())
      .endOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    fromInception: false,
    specificDate: false,
  };
  disableCommand = true;
  showWizardDialog = false;

  async upsertChemical(chemical) {
    try {
      const uploadedBy = getCurrentUser()?.fullName;
      const retVal = await MaterialService.upsertChemical(chemical, uploadedBy);

      return retVal;
    } catch (error) {
      throw error;
    }
  }

  async loadchemicals() {
    try {
      this.isLoadingChemicals = true;
      this.chemicals.clear();
      const assetId = this.mainStore.assetContextId;
      const res = await MaterialService.loadAssetChemical(assetId);
      //console.log(res);
      res.chemicals.forEach((c) => {
        this.chemicals.set(c.chemicalId, c);
      });
      this.isLoadingChemicals = false;
    } catch (error) {
      throw error;
    }
  }

  get newStockValue() {
    return this.stockData.change + this.selChem?.stock;
  }
  clearHistortyFormData() {
    this.stockData = {
      chemicalId: 0,
      name: "",
      change: 0,
      changeDate: null,
      restockTime: null,
      restockParty: "",
      assetId: mainStore.assetContextId,
      cost: 0,
      uploadedBy: "",
      uploadedOn: "",
      approvedParty: "",
      remarks: "",
      vendor: "",
      currentStock: 0,
    };
  }

  async restock(formData) {
    try {
      this.savingHistory = true;
      const newStock = this.newStockValue;
      if (newStock < 0) {
        throw new Error(`new stock values cannot be negative`);
      }
      await MaterialService.restock(formData, newStock);
      const { chemicalId } = formData;
      const chemical = toJS(this.chemicals.get(chemicalId));

      this.chemicals.set(chemicalId, { ...chemical, stock: newStock });
    } catch (error) {
      throw error;
    }
  }
  async loadStockHistory(item) {
    try {
      const { assetId, chemicalId } = item;
      const retVal = await MaterialService.loadStockHistory(
        assetId,
        chemicalId
      );
      this.stockHistory.clear();
      retVal.forEach((h) => {
        this.stockHistory.set(h.stockHistoryId, h);
      });
      console.log([...this.stockHistory.values()]);
    } catch (error) {
      throw error;
    }
  }

  async filterRange(start, end) {
    this.isfiltering = true;
    const { assetId, chemicalId } = this.selChem;
    const retVal = await MaterialService.filterStockHistory(
      assetId,
      chemicalId,
      start,
      end
    );
    this.stockHistory.clear();
    retVal.forEach((h) => {
      this.stockHistory.set(h.stockHistoryId, h);
    });
    this.isfiltering = false;
  }

  async saveConsumptions(consumptions) {
    try {
      this.isSaving = true;
      const retVal = await MaterialService.saveConsumptions(consumptions);
      console.log(retVal);
      return retVal;
    } catch (error) {
      throw error;
    }
  }

  async loadConsumptions() {
    try {
      this.isLoading = true;
      let res = [];
      res = await MaterialService.loadConsumptions(
        this.queryCriteria,
        this.mainStore.assetContextId
      );
      console.log(res);
      this.materialConsumptions.clear();
      res.consumptionHistory.forEach((consumption) => {
        this.materialConsumptions.set(consumption.materialSheetId, {
          ...consumption,
          productionDate: moment(consumption.productionDate).format("L"),

          pdYear: moment(consumption.productionDate).format("YYYY"),
          pdYearMonth: moment(consumption.productionDate).format("YYYY-MMM"),
        });
      });

      this.isLoaded = true;

      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
}


const materialStore = new MaterialStore();
export default materialStore;

